import { IconProps } from '../Icons.type'

export function TrashIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}>
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipPath="url(#a)"
        clipRule="evenodd">
        <path d="M.667 4.073c0-.368.298-.666.666-.666H14.96a.667.667 0 1 1 0 1.333H1.333a.667.667 0 0 1-.666-.667Z" />
        <path d="M2.37 4.073c0-.368.298-.666.667-.666h10.22c.367 0 .666.298.666.666v10.22a1.802 1.802 0 0 1-1.802 1.802H4.172a1.802 1.802 0 0 1-1.802-1.802V4.073Zm1.333.667v9.553a.469.469 0 0 0 .469.469h7.949a.469.469 0 0 0 .469-.469V4.74H3.703Z" />
        <path d="M8.146 1.333a2.172 2.172 0 0 0-2.172 2.173v.567a.667.667 0 1 1-1.333 0v-.568a3.505 3.505 0 0 1 7.011 0v.568a.667.667 0 0 1-1.333 0v-.568a2.172 2.172 0 0 0-2.173-2.172ZM6.443 5.678c.368 0 .667.298.667.666v6.246a.667.667 0 0 1-1.333 0V6.344c0-.368.298-.666.666-.666ZM9.85 5.678c.368 0 .666.298.666.666v6.246a.667.667 0 0 1-1.333 0V6.344c0-.368.298-.666.667-.666Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
